const serverPath = process.env.VUE_APP_RESOURCE_PATH;

export default {
  eventToUI(e) {
    const ev = e;
    ev.start_date = ev.start_date ? new Date(ev.start_date) : undefined;
    ev.end_date = ev.end_date ? new Date(ev.end_date) : undefined;
    ev.info_description = ev.info_description || '';
    ev.info_outline = ev.info_outline || '';
    ev.card_image = this.toServerUrl(ev.card_image);
    ev.hero_banner = this.toServerUrl(ev.hero_banner);
    ev.info_banner = this.toServerUrl(ev.info_banner);
    ev.bio_image = this.toServerUrl(ev.bio_image);
    ev.pdf_link = this.toServerUrl(ev.pdf_link);
    ev.ppt_link = this.toServerUrl(ev.ppt_link);
    ev.doc_link = this.toServerUrl(ev.doc_link);

    return ev;
  },
  courseToUI(c) {
    const course = c;
    course.start_date = course.start_date ? new Date(course.start_date) : undefined;
    course.end_date = course.end_date ? new Date(course.end_date) : undefined;
    course.info_description = course.info_description || '';
    course.info_topics = course.info_topics ? course.info_topics.split(/\n/) : '';
    course.info_skills = course.info_skills ? course.info_skills.split(/\n/) : '';
    course.bio_image = this.toServerUrl(course.bio_image);
    course.pdf_link = this.toServerUrl(course.pdf_link);
    course.ppt_link = this.toServerUrl(course.ppt_link);
    course.doc_link = this.toServerUrl(course.doc_link);

    return course;
  },
  toServerUrl(url) {
    if ([undefined, null, '', 'null', 'undefined'].includes(url)) return '';
    return `${serverPath}${url}`;
  },
  getImage(image, type) {
    if (!type) return image;

    const imageName = image.match(/\/(.*[^/]+)\.[a-zA-Z0-9]{2,5}$/)[1];
    return image.replace(imageName, `${imageName}-${type}`);
  },

  twoDigits(numString) {
    const num = Number(numString);
    if (num >= 0 && num < 10) return `0${num.toString()}`;
    if (num > -10 && num < 0) return `-0${(-1 * num).toString()}`;
    return num.toString();
  },
};
